<template>
  <div id="app">
    <div>
      <div v-if="isBlocked">Нет доступа!</div>
      <b-navbar toggleable="lg" type="dark" variant="dark" v-if="!isBlocked">
        <b-navbar-brand to="/"
          >Savanna Admin ({{ this.appVersion }})</b-navbar-brand
        >
        <b-collapse is-nav id="nav_collapse" v-if="isLoggedIn">
          <b-navbar-nav small v-if="isAdmin || isDeveloper">
            <b-nav-item to="/">Dashboard</b-nav-item>
            <b-nav-item-dropdown text="Combinations" right>
              <b-dropdown-item to="/combinations">Combinations</b-dropdown-item>
              <b-dropdown-item to="/pipelines">Pipelines</b-dropdown-item>
              <b-dropdown-item to="/testRequest">TestRequest</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item to="/whitelabels">Whitelabels</b-nav-item>
            <b-nav-item to="/platforms">Platforms</b-nav-item>
            <b-nav-item to="/builds">Builds</b-nav-item>

            <b-nav-item to="/techSupport">TechSupport</b-nav-item>

            <!-- //_DEVELOPER_ADMIN_PLACEHOLDER -->
            <b-nav-item-dropdown text="UsersInfo" v-if="isAdmin" right>
              <b-dropdown-item to="/users" v-if="isAdmin"
                >Users</b-dropdown-item
              >
              <b-dropdown-item to="/userslogs" v-if="isAdmin"
                >Users Logs</b-dropdown-item
              >
            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="Installations">
              <b-dropdown-item to="/installations"
                >Installations</b-dropdown-item
              >
              <b-dropdown-item to="/appinfo">AppInfo</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown text="Lg/Samsung testers" right>
              <b-dropdown-item to="/testerEmails"
                >Tester emails</b-dropdown-item
              >
              <b-dropdown-item to="/testerIP">Tester IPs</b-dropdown-item>
              <b-dropdown-item to="/testersPhones"
                >Tester Phones</b-dropdown-item
              >
              <b-dropdown-item to="/appVersionsOnTest"
                >App versions on test</b-dropdown-item
              >
            </b-nav-item-dropdown>
            <b-nav-item to="/localisations">Localisations</b-nav-item>
            <b-nav-item to="/wlConfig">WL Configs</b-nav-item>
            <b-nav-item-dropdown text="A/B" right>
              <b-dropdown-item to="/abtesting">Experiments</b-dropdown-item>
              <b-dropdown-item to="/goalsAbtesting"
                >Create goals</b-dropdown-item
              >
              <b-dropdown-item to="/achievedGoals"
                >Achieved goals</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>
          <b-navbar-nav v-if="isTester">
            <b-nav-item to="/combinations">Combinations</b-nav-item>
            <b-nav-item to="/builds">Builds</b-nav-item>
            <b-nav-item to="/pipelines">Pipelines</b-nav-item>
            <b-nav-item to="/testerIP">Tester IPs</b-nav-item>
            <b-nav-item to="/testerEmails">Tester emails</b-nav-item>
            <!-- //_TESTER_PLACEHOLDER -->
          </b-navbar-nav>
          <b-navbar-nav v-if="isCustomercare">
            <b-nav-item to="/appinfo">AppInfo</b-nav-item>
            <!-- //_CUSTOMERCARE_PLACEHOLDER -->
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav small class="ml-auto">
            <b-nav-item-dropdown>
              <!-- Using button-content slot -->
              <template slot="button-content">
                <span class="user-name">
                  Logged as
                  <em>{{ $store.state.user.email }}</em>
                </span>
              </template>
              <b-dropdown-item @click="logout">Logout</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div id="innerApp">
      <router-view />
    </div>
    <notifications group="main"></notifications>
  </div>
</template>

<script>
import { HTML_CODES, appVersion } from '@/config/constants';
import Vue from 'vue';
import isBlockedByOrigin from './helpers/isBlockedByOrigin';

export default {
  computed: {
    isBlocked: function() {
      return isBlockedByOrigin(this.$store);
    },
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    appVersion: () => appVersion,
    isTester: function() {
      return this.$store.getters.role === 'tester';
    },
    isCustomercare: function() {
      return this.$store.getters.role === 'customercare';
    },
    isDeveloper: function() {
      return this.$store.getters.role === 'developer';
    },
    isAdmin: function() {
      return this.$store.getters.role === 'admin';
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    }
  },
  created: function() {
    this.$http.interceptors.response.use(undefined, err => {
      return new Promise((resolve, reject) => {
        if (
          err?.response?.status === HTML_CODES.UNAUTHORIZED &&
          this.$store.state &&
          this.$store.state.token !== ''
        ) {
          Vue.notify({
            group: 'main',
            title: `You need to login again`,
            text: 'Error',
            type: 'error'
          });
          this.logout();
          reject(err);
        } else if (err?.response?.status !== HTML_CODES.SUCCESS) {
          reject(err);
        } else {
          resolve();
        }
      });
    });
  }
};
</script>

<style lang="scss">
#innerApp {
  padding: 1em;
}
.nav-item .router-link-exact-active {
  color: white !important;

  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

ul {
  outline: 0;
}

.user-name {
  max-width: 13rem;
  overflow-x: hidden;
  display: inline-block;
  vertical-align: middle;
}
</style>
